/**
 * Tamara Comolli – Drawer schließt bei Klick außerhalb
 * ------------------------------------------------------
 * Ergänzt die vorhandenen <drawer-component>-Elemente (Details-, Info-,
 * Versand-, Ketten-/Ringgrößen-Drawer) um "Klick außerhalb schließt".
 * Greift nur auf die öffentliche API des Custom Elements zu
 * (classList, closeDrawer(), lastTrigger) und verändert moonbase-main.js
 * NICHT. Muss nach moonbase-main.js geladen werden.
 */
document.addEventListener("click", function (event) {
  document.querySelectorAll("drawer-component.drawer--open").forEach(function (drawer) {
    // Klick, der den Drawer gerade erst geöffnet hat, ignorieren
    if (
      drawer.lastTrigger &&
      (event.target === drawer.lastTrigger || drawer.lastTrigger.contains(event.target))
    ) {
      return;
    }
    // Der X-Button hat schon seinen eigenen Click-Handler
    if (event.target.closest && event.target.closest("[drawer-close-button]")) {
      return;
    }
    // Klicks innerhalb des sichtbaren Panels sollen nicht schließen
    var panel = drawer.querySelector(".wrapper .content");
    if (panel && panel.contains(event.target)) {
      return;
    }
    if (typeof drawer.closeDrawer === "function") {
      drawer.closeDrawer();
    }
  });
});